// Fichier i18n.js avec amélioration pour les traductions manquantes

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import { Language } from "./Language";
import translationEN from './i18n/en.json';
import translationFR from './i18n/fr.json';
 
let defaultLanguage = Language.FR;
 
// the translations
const resources = {
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  }
};

// Fonction pour transformer une clé de traduction en texte lisible
// Exemple: "common.manage-provider-types" -> "Manage provider types"
function formatMissingKey(key) {
  // Prendre la dernière partie de la clé (après le dernier point)
  const lastPart = key.split('.').pop();
  
  // Remplacer les tirets par des espaces
  const withSpaces = lastPart.replace(/-/g, ' ');
  
  // Mettre en majuscule la première lettre et retourner le résultat
  return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: defaultLanguage,
    keySeparator: ".",
    interpolation: {
      escapeValue: false
    },
    
    // Configuration pour gérer les clés manquantes
    saveMissing: true,
    missingKeyHandler: (lng, ns, key, fallbackValue) => {
      // Option: journaliser les clés manquantes pour les ajouter plus tard
      console.log(`Traduction manquante: ${key}`);
    },
    
    // Formatter les clés manquantes en texte lisible au lieu d'afficher la clé brute
    parseMissingKeyHandler: (key) => {
      return formatMissingKey(key);
    }
  });

// Ajouter une méthode helper pour traduire avec un fallback explicite
i18n.getTranslationWithFallback = (key, fallback, options = {}) => {
  const translation = i18n.t(key, { ...options, defaultValue: fallback });
  return translation === key ? fallback : translation;
};

export default i18n;